// extracted by mini-css-extract-plugin
export default {"wrapper":"DailyStrategySelector_wrapper__G37C+","active":"DailyStrategySelector_active__FKz4A"};